module.exports = __webpack_public_path__ + "static/media/card-bg1-light@2x.8abf97cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_42/imgs/card-bg1-light@2x.png
// module id = 995
// module chunks = 0